class ProductCard extends HTMLElement {
  constructor() {
    super();

    this.productUrl = null;
  }

  connectedCallback() {
    this.productUrl = this.resolveProductUrl();

    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
  }

  /*
    Le lien de la carte porte l'URL localisée : préfixe de langue, route et handle traduits
    (ex. /de/produkte/lockenroutine). L'attribut data-product-url est rendu dans un snippet,
    contexte où l'URL perd sa localisation et reste dans la langue primaire (/products/...).
    On lit donc le lien en priorité, sinon un clic hors du lien renvoyait vers la page
    française depuis le site allemand.
  */
  resolveProductUrl() {
    const link =
      this.querySelector('a.product-card-group-link[href]') || this.querySelector('a[href]');

    return (link && link.getAttribute('href')) || this.dataset.productUrl || null;
  }

  handleClick(event) {
    if (event.target instanceof Element) {
      const interactiveElement = event.target.closest(
        'button, input, label, select, [tabindex="1"], a, quick-add-component, add-to-wishlist-button',
      );
      if (interactiveElement) return;
    }

    const url = this.resolveProductUrl() || this.productUrl;
    if (!url) return;

    window.location.href = url;
  }
}

if (!customElements.get('product-card')) {
  customElements.define('product-card', ProductCard);
}
